import { EAnswerTypes, EQuestionType } from "#models/questionnaire";
import {
    CalendarTodayOutlined,
    CheckOutlined,
    DescriptionOutlined,
    EmailOutlined,
    ExpandMoreOutlined,
    FiberManualRecordOutlined,
    FormatAlignLeftOutlined,
    ImageOutlined,
    LocationOnOutlined,
    PersonOutline,
    PhoneOutlined
} from '@material-ui/icons';

export const fieldQuestionTypes = [
  EQuestionType.Name,
  EQuestionType.Email,
  EQuestionType.Number,
  EQuestionType.TextField,
  EQuestionType.PostalCode,
  EQuestionType.Boolean,
  EQuestionType.Select
];

export const contactQuestionTypes = [
  EQuestionType.Name,
  EQuestionType.Email,
  EQuestionType.Number,
  EQuestionType.PostalCode,
  EQuestionType.TextField
];

export const IconQuestion = {
  [EQuestionType.Name]: PersonOutline,
  [EQuestionType.Email]: EmailOutlined,
  [EQuestionType.Number]: PhoneOutlined,
  [EQuestionType.Picture]: ImageOutlined,
  [EQuestionType.Multiple]: CheckOutlined,
  [EQuestionType.PostalCode]: LocationOnOutlined,
  [EQuestionType.Select]: ExpandMoreOutlined,
  [EQuestionType.Date]: CalendarTodayOutlined,
  [EQuestionType.TextField]: FormatAlignLeftOutlined,
  [EQuestionType.Boolean]: FiberManualRecordOutlined,
  [EQuestionType.LeadGeneration]: DescriptionOutlined
};

export const contactField = {
  [EAnswerTypes.FirstName]: 'firstName',
  [EAnswerTypes.LastName]: 'lastName',
  [EAnswerTypes.Email]: 'email',
  [EAnswerTypes.Number]: 'contact',
  [EAnswerTypes.PostalCode]: 'postalCode'
};

export const dateLead = 'schedule-date';
export const timeLead = 'schedule-slot';
